import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import "./auth.css"; // Add styles for consistency
import axiosInstance from "../api/axiosInstance";
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();


  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axiosInstance.post("/auth/login", { email, password });
  
      // ✅ Store JWT token & role in localStorage
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("userRole", res.data.role); // ✅ Store role
      navigate("/"); // ✅ Redirect to home
    } catch (err) {
      setError("Invalid email or password");
    }
  };

  

  return (
    <div className="auth-container">
      <h2>Login</h2>
      {error && <p className="error">{error}</p>}
      <form onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit">Login</button>
      </form>
      <p>Don't have an account? <a href="/signup">Sign Up</a></p>
    </div>
  );
};

export default Login;
